import tippy from 'tippy.js';

import 'tippy.js/animations/shift-toward.css';

const initTooltip = () => {
  const tooltipItems = document.querySelectorAll<HTMLElement>('.i-tooltip:not(.--initialized)');

  tooltipItems.forEach(item => {
    const target = item.querySelector<HTMLElement>('.i-tooltip__target');
    const content = item.querySelector<HTMLElement>('.i-tooltip__content');

    if (!content || !target) return;

    content.classList.remove("d-none")

    tippy(target, {
      offset: [-8, 8],
      content: content,
      placement: 'bottom-start',
      maxWidth: 'none',
      animation: 'shift-toward',
      delay: 500,
      trigger: 'mouseenter click',
    })
    item.classList.add("--initialized")
  })
}

initTooltip()
document.addEventListener("tooltipReinit", initTooltip)
